import React from "react";

export const SectionHeading = ({
    heading,
    subHeading,
    color = "text-black",
    className,
}) => {
    return (
        <div
            className={`text-center flex flex-col w-full gap-5 mb-5 ${color} ${className} md:max-w-[90%] xl:max-w-[60%] mx-auto`}
        >
            <h2 className="text-[28px] md:text-[36px] xl:text-[50px] font-medium leading-[38px] md:leading-[46px] xl:leading-[60px]">
                {heading}
            </h2>
            {subHeading ? (
                <p className="font-normal text-[14px] md:text-[16px] xl:text-[18px]  leading-[22px] md:leading-[26px] xl:leading-[26px]">
                    {subHeading}
                </p>
            ) : null}
        </div>
    );
};
